"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWorkScheduleSlotApiResponseSchema = void 0;
const zod_1 = require("zod");
const work_schedule_slot_1 = require("./work-schedule-slot");
exports.createWorkScheduleSlotApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(work_schedule_slot_1.workScheduleSlotApiSchema),
    included: zod_1.z
        .array(zod_1.z.union([
        work_schedule_slot_1.workScheduleSlotDoctorAttendingApiSchema,
        work_schedule_slot_1.workScheduleSlotSequenceApiSchema,
    ]))
        .optional()
        .default([]),
});
